import { Transaction } from "../models/Transaction";
import { Cols, TransactionType } from "../shared/Consts";
import PortUtils from "../portlibs/PortUtils";
import Holding from "../models/Holding";
import { usePath } from "../libs/path/PathProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import TransactionTable from "../components/widgets/TransactionTable";
import TaxToolbar from "../components/tax/TaxToolbar";

function filterTaxTrans(rows:Transaction[], holding:Holding, year:number){
    let total = 0;
    for(const trans of holding.transactions){
        if (trans.date.getFullYear()!=year) {}
        else if (trans.isSell) total += trans.gain;
        else if (trans.isDividend) total += trans.quantity;
    }
    if (total) {
        const trans = new Transaction(holding, {_id:holding.id})
        trans.gain = total
        rows.push(trans)
    }
    return total * holding.exchange;
}

export default function TaxPage(){
    const {query} = usePath();
    const {account,currency,filter} = PortUtils.getFilter(query);
    const {portfolio} = usePortfolio()
    const year = parseInt(query.year as string) || new Date().getFullYear()
    const cols = [Cols.name, Cols.gain]
    const holdings = portfolio.filter(currency, filter, account, true)
    const rows : Transaction[] = []
    let gain = 0;
    for(let holding of holdings){
        gain += filterTaxTrans(rows, holding, year)
    }
    const footer = {id:"summary",type:TransactionType.all,date:new Date(0),quantity:0,accountId:-1,price:0,note:"",gain,
        value:(col:string) => col==Cols.gain ? PortUtils.cellValue(Cols.gain, footer.gain, {currency:0}) : ""
    }
    return <>
        <TaxToolbar/>
        <div id="tax" className="flex1 scroller"><TransactionTable tableName="tax" cols={cols} rows={rows} footer={footer}/></div>
    </>

}